import { render, staticRenderFns } from "./DefaultInput.vue?vue&type=template&id=53b2298a"
import script from "./DefaultInput.vue?vue&type=script&lang=ts"
export * from "./DefaultInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports